export interface GenericQueryPart {
    strategy: Strategy;
    operator: Operator;
    field: string;
    value: string;
}

export enum Operator {
    EQUALS = 'equals',
    NOT = 'not',
    CONTAINS = 'contains'
}

export enum Strategy {
    AND = 'and',
    OR = 'or'
}
